<div class="superadmin-details-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ typeLabel }} User Details</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="dialog-content">
    <!-- Status Badge -->
    <div class="status-section">
      <span class="status-badge-large" [ngClass]="user.status === 'Active' ? 'active' : 'inactive'">
        <mat-icon>{{ user.status === 'Active' ? 'check_circle' : 'block' }}</mat-icon>
        {{ user.status }}
      </span>
    </div>

    <!-- Personal Information -->
    <section class="info-section">
      <h3>
        <mat-icon>person</mat-icon>
        Personal Information
      </h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Full Name</label>
          <p>{{ user.fullName }}</p>
        </div>
        <div class="info-item">
          <label>First Name</label>
          <p>{{ user.firstName }}</p>
        </div>
        <div class="info-item">
          <label>Last Name</label>
          <p>{{ user.lastName }}</p>
        </div>
      </div>
    </section>

    <mat-divider></mat-divider>

    <!-- Contact Information -->
    <section class="info-section">
      <h3>
        <mat-icon>contact_mail</mat-icon>
        Contact Information
      </h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Email</label>
          <p>{{ user.email }}</p>
        </div>
        <div class="info-item">
          <label>Phone Number</label>
          <p>{{ user.phoneNumber || 'Not provided' }}</p>
        </div>
      </div>
    </section>

    <mat-divider></mat-divider>

    <!-- Account Information -->
    <section class="info-section">
      <h3>
        <mat-icon>admin_panel_settings</mat-icon>
        Account Information
      </h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Account Type</label>
          <p>{{ typeLabel }}</p>
        </div>
        <div class="info-item">
          <label>User ID</label>
          <p class="monospace">{{ user.id }}</p>
        </div>
        <div class="info-item">
          <label>Created Date</label>
          <p>{{ user.createdAt | date: 'full' }}</p>
        </div>
        <div class="info-item">
          <label>Last Login</label>
          <p>{{ user.lastLoginAt ? (user.lastLoginAt | date: 'full') : 'Never logged in' }}</p>
        </div>
        <div class="info-item">
          <label>Organization</label>
          <p class="text-muted">None ({{ typeLabel }} — global access)</p>
        </div>
      </div>
    </section>

    <mat-divider></mat-divider>

    <!-- Actions Section -->
    <section class="actions-section">
      <h3>
        <mat-icon>settings</mat-icon>
        Actions
      </h3>
      
      <div class="action-buttons">
        <button mat-stroked-button color="accent" (click)="resetPassword()">
          <mat-icon>lock_reset</mat-icon>
          Reset Password
        </button>

        @if(user.status === 'Active') {
        <button mat-stroked-button color="warn" (click)="deactivateUser()">
          <mat-icon>block</mat-icon>
          Deactivate User
        </button>
        } @else {
        <button mat-stroked-button color="primary" (click)="reactivateUser()">
          <mat-icon>check_circle</mat-icon>
          Reactivate User
        </button>
        }

        <button mat-stroked-button class="delete-button" (click)="deleteUser()">
          <mat-icon>delete</mat-icon>
          {{ isEventManager ? 'Revoke Role' : 'Delete User' }}
        </button>
      </div>

      <div class="warning-box">
        <mat-icon>warning</mat-icon>
        <p>
          @if (isEventManager) {
            <strong>Note:</strong> Global Event Managers can create and manage events across all organizations.
            Deactivating or revoking this role will remove that access immediately.
          } @else {
            <strong>Warning:</strong> SuperAdmin users have full system access.
            Deactivating or deleting a SuperAdmin user is a critical action that should only be performed when necessary.
          }
        </p>
      </div>
    </section>
  </div>

  <mat-divider></mat-divider>

  <div class="dialog-footer">
    <button mat-button (click)="close()">Close</button>
  </div>
</div>